module.exports = require("pinkie-promise");


//////////////////
// WEBPACK FOOTER
// external "pinkie-promise"
// module id = 95
// module chunks = 0 1 2